export const buttonVariants = {
    visible: {
        opacity: 1,
    },
    hidden: {
        opacity: 0,
    },
};
